import useTimelineData from "@src/utility_functions/customHooks/useTimelineData";

// Row labels come from TimelineDataContext (the same row documents the chart
// renders) rather than the chart's DOM — the select works even when no chart
// is mounted (e.g. the Header's Add Interval path), falling back to chartID
// exactly as the old data-attribute lookup did.
export const RowSelectInput = (props) => {
  const timelineRows = useTimelineData()?.timelineData ?? [];
  const userOwnedRows = props.rowsIncludedState.filter(
    (row) => row.ownerID === props.loggedInUserID,
  );

  const firstUserOwnedRow = userOwnedRows[0]?.id;

  return (
    <>
      <div className="_margin-bottom--1rem">
        <label htmlFor="chartID">Select Row</label>
        <select
          id="chartID"
          name="chartID"
          onChange={(e) => props.setSelectedRow(e.target.value)}
          defaultValue={firstUserOwnedRow}
          value={props.selectedRowId}
        >
          {userOwnedRows.map((row) => {
            const rowDocument = timelineRows.find(
              (timelineRow) => timelineRow.id === row.chartID,
            );
            const label = rowDocument?.label || row.chartID;

            return (
              <option key={row.chartID} value={row.chartID}>
                {label}
              </option>
            );
          })}
          ;
        </select>
      </div>
    </>
  );
};
